var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LMap',{ref:"map",staticStyle:{"height":"100%","width":"100%","z-index":"1"},attrs:{"options":{zoomSnap: 0.5},"center":_vm.normalizedCenter,"zoom":_vm.zoom}},[_c('LTileLayer',{attrs:{"url":_vm.url,"attribution":_vm.attribution}}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }